export default "__VITE_ASSET__D8R0BRdU__"